import { Application } from "@hotwired/stimulus"

import DropdownController from "../controllers/dropdown_controller"
import SearchboxController from "../../../app/components/ui/form/searchbox_controller"

import "@assets/stylesheets/utility/_tdd-css-vars.scss"
// import "@assets/stylesheets/tailwind.css"
import "@assets/stylesheets/globals/shim.scss"

const application = Application.start()

// Configure Stimulus development experience
application.warnings = true
application.debug = process.env.NODE_ENV === "development"
window.Stimulus = application

document.addEventListener("turbo:before-fetch-request", async event => {
  document.body.classList.add("wait")
})

document.addEventListener("turbo:before-fetch-response", async event => {
  document.body.classList.remove("wait")
})

application.register("dropdown", DropdownController)
application.register("ui--form--searchbox", SearchboxController)
